import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { selectActiveProjects, selectBasemap } from "../../reducers";
import PropTypes from "prop-types";
import { getIcon } from "../../modules/hub";
import { setActiveProject } from "../../actions/ui";
import { StaticMap, Marker } from "react-map-gl";
import styles from "./popup.module.scss";

const Popup = props => {
    const { activeProjects, setActiveProject, basemap } = props;
    const [viewingProjectIndex, setViewingProjectIndex] = useState(0);
    useEffect(() => {
        setViewingProjectIndex(0);
    }, [activeProjects]);
    const viewingProject = activeProjects[viewingProjectIndex];
    if (!viewingProject) return null;

    return (
        <div onClick={() => setActiveProject(null)} className={styles.overlay}>
            <div
                onClick={e => e.stopPropagation()}
                className={styles.projectPopup}
            >
                <p
                    className={styles.multipleHubText}
                    style={{
                        opacity: activeProjects.length > 1 ? 1 : 0,
                    }}
                >
                    There are {activeProjects.length} community projects at this
                    address.
                </p>
                <div className={styles.iconAndNameRow}>
                    {activeProjects.length > 1 && (
                        <img
                            className={styles.chevronIcon}
                            src={
                                process.env.PUBLIC_URL +
                                "/img/chevron-left-solid.svg"
                            }
                            alt={"right arrow"}
                            role="button"
                            disabled={viewingProjectIndex === 0}
                            data-disabled={viewingProjectIndex === 0}
                            onClick={e => {
                                setViewingProjectIndex(x => x - 1);
                            }}
                        />
                    )}
                    <div className={styles.iconAndName}>
                        <img
                            className={styles.markerIcon}
                            src={getIcon(viewingProject.hubName)}
                            alt={`Marker icon for: ${viewingProject.hubName}`}
                        />{" "}
                        <h3>My Community Project - {viewingProject.hubName}</h3>
                    </div>
                    {activeProjects.length > 1 && (
                        <img
                            className={styles.chevronIcon}
                            src={
                                process.env.PUBLIC_URL +
                                "/img/chevron-right-solid.svg"
                            }
                            alt={"right arrow"}
                            role="button"
                            disabled={
                                viewingProjectIndex ===
                                activeProjects.length - 1
                            }
                            data-disabled={
                                viewingProjectIndex ===
                                activeProjects.length - 1
                            }
                            onClick={e => {
                                if (
                                    viewingProjectIndex ===
                                    activeProjects.length - 1
                                ) {
                                    return;
                                }
                                setViewingProjectIndex(x => x + 1);
                            }}
                        />
                    )}
                </div>
                <button
                    autoFocus
                    className={styles.closeButton}
                    onClick={() => setActiveProject(null)}
                >
                    <img
                        src={process.env.PUBLIC_URL + "/img/cross.svg"}
                        alt="Cross"
                    />
                </button>
                <p style={{ marginTop: 10 }}>
                    <label>{viewingProject["Project Title"]}</label>
                </p>
                <p>
                    <span> {viewingProject["Brief project description"]}</span>
                </p>

                <p>
                    <label>Grant amount:</label>
                    <span>
                        {(viewingProject["Grant amount"] || 0).toLocaleString(
                            "en-AU",
                            {
                                style: "currency",
                                currency: "AUD",
                                minimumFractionDigits: 0,
                            }
                        )}
                    </span>
                </p>

                <p>
                    <label>Project sponsor:</label>
                    <span> {viewingProject["Project sponsor"]}</span>
                </p>
                <p>
                    <label>Status:</label>
                    <span> {viewingProject["Status"]}</span>
                </p>

                {viewingProject["Location"] && (
                    <p>
                        <label>Location:</label>
                        <span>{viewingProject["Location"]}</span>
                    </p>
                )}

                {/* <p>
                    <label>Project Activity:</label>
                    <span> {viewingProject["Project Activity 1"]}</span>
                </p> */}

                <StaticMap
                    mapboxApiAccessToken={
                        process.env.REACT_APP_MAPBOX_API_TOKEN
                    }
                    width={"100%"}
                    height={200}
                    zoom={13}
                    mapStyle={
                        basemap === "ROADMAP"
                            ? "mapbox://styles/mapbox/streets-v11"
                            : `mapbox://styles/mapbox/satellite-v9`
                    }
                    longitude={parseFloat(viewingProject.Longitude)}
                    latitude={parseFloat(viewingProject.Latitude)}
                >
                    <Marker
                        latitude={parseFloat(viewingProject.Latitude)}
                        longitude={parseFloat(viewingProject.Longitude)}
                    >
                        <img
                            style={{
                                transform: `translate(-50%, -100%)`,
                            }}
                            alt="pin"
                            src={process.env.PUBLIC_URL + "/img/green-pin.svg"}
                        />
                    </Marker>
                </StaticMap>
            </div>
        </div>
    );
};

const mapStateToProps = s => ({
    activeProjects: selectActiveProjects(s),
    basemap: selectBasemap(s),
});
const mapDispatchToProps = {
    setActiveProject,
};
Popup.propTypes = {
    setActiveProject: PropTypes.func.isRequired,
    activeProjects: PropTypes.array.isRequired,
    basemap: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Popup);



// WEBPACK FOOTER //
// ./src/components/popup/popup.js